import layout from "@/views/page/layIndex";
export default [
  {
    path: '/',
    name: '首页',
    component: () =>
      import('@/views/page/index'),
    meta: {
      //   keepAlive: true,
      //   isTab: false,
      //   isAuth: false
    }
  },
  {
    path: '/maintenance',
    name: '首页C',
    component: () =>
      import('@/views/page/index'),
    meta: {
      //   isAuth: false
    }
  },
  {
    path: '/mcheckClock/',
    component: layout,
    children: [{
      path: 'index',
      name: '考勤打卡',
      component: () =>
        import(/* webpackChunkName: "page" */ '@/views/mcheckClock/index'),
      meta: {
        isAuth: false,
        title:'考勤打卡'
      },

    }]
  },
  {
    path: '/mworkSite/',
    component: layout,
    children: [{
      path: 'index',
      name: '现场工作',
      component: () =>
        import(/* webpackChunkName: "page" */ '@/views/mworkSite/index'),
      meta: {
        isAuth: false,
        title:'现场工作'
      },

    }]
  },
  {
    path: '/bindInfo/',
    component: layout,
    children: [{
      path: '',
      name: '绑定账号',
      component: () =>
        import(/* webpackChunkName: "page" */ '@/views/page/bindInfo'),
      meta: {
        // keepAlive: true,
        // isTab: false,
        isAuth: false,
        title: '绑定账号'
      },

    }]
  },
  {
    path: '/mworkSite/',
    component: layout,
    children: [{
      path: 'logList',
      name: '',
      component: () =>
        import(/* webpackChunkName: "page" */ '@/views/mworkSite/logList'),
      meta: {
        isAuth: false,
        title: '工作记录'
      },

    }]
  },
  {
    path: '/mworkSite/',
    component: layout,
    children: [{
      path: 'history',
      name: '',
      component: () =>
        import(/* webpackChunkName: "page" */ '@/views/mworkSite/history'),
      meta: {
        isAuth: false,
        title: '工作详情'
      },

    }]
  },
]


// WEBPACK FOOTER //
// ./src/router/maintenance/index.js